import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import toast from "react-hot-toast";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import { getPermissionInfo, getSelectedOption, localDate, showLocalDate } from "../../../_common/functions";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { useFacilityManagersSelector } from "../../../store/selectors/masterSelector";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import CreateAssetsModal from "./createAssets.modal";
import { AgGridReact } from "ag-grid-react";
import Label from "../../../components/elements/form/fromLabel";
import { Link } from "react-router-dom";
import AssetStatus from "../../Assets/_components/assetStatus";
import Icon from "../../../components/icons";
import ModalWrapper from "../../../components/modalWrapper";
import CollectAudioData from "./collectAudioData";
import Loader from "../../../components/loader";
import { useUserSelector } from "../../../store/selectors/userSelector";
interface AssetsFormProps {
    _ref?: any;
    editData?: any;
    onCreate?: () => void
    onCancel?: () => void
}

type AssetsFormValueType = {
    assetID?: number;
    workRequestCode: string;
    workRequestStatusID: any;
    line: string;
    facilityID: Option;
    subFacilityIDs: any;
    incidentDate: Date;
    zone: string;
    workRequestPriorityID: any;
    description: string;
    priorityIDs: any;
    requesterIDs: any;
    statusIDs: string;
    notes: string;
    requesterID: string;
    assetImage: any,
};

const CreateWorkRequest: React.FC<AssetsFormProps> = ({ _ref, editData, onCreate = () => { }, onCancel = () => { } }) => {

    const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<AssetsFormValueType>({
        defaultValues: {
            incidentDate: new Date(),
        }
    });
    const { showLoader, hideLoader } = useAppLoader();
    const [woloader, setWoloader] = useState<boolean>(false);
    const [workRequestCode, setWorkRequestCode] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [priority, setPriority] = useState<any>([]);


    const [statusList, setStatusList] = useState<any>([]);
    const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
    const [selectedAssets, setSelectedAssets] = useState<any>([]);
    const [attachmentList, setAttachmentList] = React.useState<any[]>([]);
    const [workStatus, setWorkStatus] = useState<boolean>(false);

    const [partsAttachment, setPartsAttachment] = useState<any>(null);
    const [recordFile, setRecordFile] = useState<any>(null);

    const [recordData, setRecordData] = useState<any>(null);

    const commonApi: any = useCommonApi();
    const workRequestAPI: any = useWorkRequestApi();


    const defaultLatitude = 40.712776; // Example default latitude (New York)
    const defaultLongitude = -74.005974; // Example default longitude (New York)

    const assetApi: any = useAssetsApi();
    const facilityApi: any = useFacilitiesApi();

    const facilityWatch = watch("facilityID");
    const subFacilityWatch = watch("subFacilityIDs");


    const users = useFacilityManagersSelector();

    const createAssetModalRef: any = useRef();
    const gridRef = useRef<AgGridReact | null>(null);

    const recordaudioModalRef: any = useRef();

    const [rowData, setRowData] = useState<any>([]);

    let imgExt = ['.png', '.jpg', '.jpeg', '.webp'];

    const loggedinuser: any = useUserSelector();

    const columnDefs = [
        { headerName: 'Asset ID', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', width: 110 },
        { headerName: 'Asset Name', field: 'name', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p> },
        // { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]',  width: 160, cellRenderer:titleCell },
        {
            headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', width: 160, cellStyle: { alignItems: 'center' }, cellRenderer: (data: any) => <AssetStatus asset={data.data} canChange={getPermissionInfo('/work-request', "Change Assets Status", loggedinuser)} onUpdate={(cb: any) => {
                console.log("CB is", cb);
                console.log("data.data", data.data);
                data.data.statusID = cb.id;
                data.data.statusName = cb.label;
            }} />
        },
        { headerName: 'Actions', field: '', headerClass: 'bg-[#f0f0f0]', width: 150, cellStyle: { alignItems: 'center' }, cellRenderer: (params: any) => <button type="button" onClick={() => deleteRow(params)}>Delete</button> }
    ]

    const deleteRow = (params: any) => {
        const rowId = params.data.assetID;
        console.log("fasfaf", params)
        const updatedData = rowData.filter((row: any) => row.assetID !== rowId);
        setRowData(updatedData);
        setSelectedAssets(updatedData)
        console.log("fasfafffdsfds", updatedData)
    };


    const getWorkCode = () => {
        const payload = {};
        workRequestAPI.GetCode(payload, (resp: any) => {
            setWorkRequestCode(resp.code);
        }, (error: any) => {
            console.log("error =>", error);
            toast.error(error);
        });
    };

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(payload, (resp: any) => {
            let facilitylist: any = [];
            resp.facilityList.map((facilist: any) => {
                facilitylist.push({
                    label: facilist.facilityName,
                    value: facilist.facilityID,
                    data: facilist
                });
            });
            setFacilityoption(facilitylist);
        }, (error: any) => {
            console.log("error =>", error);
            toast.error(error);
        });
    };

    const GetPriorityList = () => {
        const payload = {};
        workRequestAPI.GetPriorityList(payload, (resp: any) => {
            let facilitylist: any = [];
            resp.workRequestPriorityList.map((facilist: any) => {
                facilitylist.push({
                    label: facilist.workRequestPriorityName,
                    value: facilist.workRequestPriorityID,
                    data: facilist
                });
            });
            setPriority(facilitylist);
        }, (error: any) => {
            console.log("error =>", error);
            toast.error(error);
        });
    };


    const GetStatusList = () => {
        const payload = {};
        workRequestAPI.GetStatusList(payload, (resp: any) => {
            let deptlist: any = [];
            resp.workRequestStatusList.map((facilist: any) => {
                deptlist.push({
                    label: facilist.workRequestStatusName,
                    value: facilist.workRequestStatusID,
                });
            });
            setStatusList(deptlist);
            setValue("workRequestStatusID", getSelectedOption(1, deptlist));
            setWorkStatus(true);
        }, (error: any) => {
            console.log("error =>", error);
            toast.error(error);
        });
    };

    const getsubfacilityList = (_facilityID: any) => {
        setValue("workRequestStatusID", getSelectedOption(1, statusList));
        const payload = { facilityID: _facilityID };
        facilityApi.getSubFacilityList(payload, (resp: any) => {
            let subfacilityoption: any = resp?.subFacilityList?.map((subFacility: any) => {
                return {
                    label: `${subFacility.subFacilityTypeName} - ${subFacility.no}`,
                    value: subFacility.subFacilityID,
                }
            });
            console.log('XXXX - subfacilityoption', subfacilityoption);
            setsubfacilityoption(subfacilityoption);
            if (editData) {
                const selectedOptions: any = editData.subFacilityIDs?.split(',').map((subfacid: any, index: number) => {
                    return {
                        label: editData.subFacilityNames.split(',')[index].trim(),
                        value: subfacid.trim()
                    }
                });
                setTimeout(() => {
                    setValue("subFacilityIDs", selectedOptions);
                }, 500);
            }
        }, (error: any) => {
            console.log('error =>', error);
            setsubfacilityoption([]);
            toast.error(error);
        });
    }

    const onSubmit: SubmitHandler<AssetsFormValueType> = (data) => {
        //  const AssData = selectedAssets.map((node: any) => node.assetID);
        const AssData = (rowData?.map((item: any) => {
            return {
                assetID: item.assetID
            }
        }));
        let payload: any = {
            //"workRequestID": 0,
            "workRequestCode": workRequestCode,
            "workRequestStatusID": data.workRequestStatusID?.value,
            "incidentDate": data?.incidentDate,
            "line": data?.line,
            "zone": data?.zone,
            "workRequestPriorityID": data?.priorityIDs?.value,
            "facilityID": data?.facilityID?.value,
            "subFacilityIDs": data?.subFacilityIDs?.map((item: any) => item.value),
            "description": data?.description,
            // "priorityIDs": data?.priorityIDs?.value,
            "requesterID": data?.requesterIDs?.value,
            "statusIDs": data?.workRequestStatusID?.value,
            "notes": data?.notes,
            "assets": AssData
        }
        if (editData) {
            payload['workRequestID'] = editData.workRequestID;
        }


        showLoader();
        workRequestAPI.SaveWorkRequest(payload, async (resp: any) => {
            const formData = new FormData();
            if (partsAttachment) {
                for (let i = 0; i < partsAttachment.length; i++) {
                    formData.append('InputFile' + i, partsAttachment[i]);
                }
                formData.append('workRequestID', editData ? editData?.workRequestID : resp?.returnID);
                const wrattchresp = await new Promise((resolve, reject) => {
                    workRequestAPI.UploadImage(formData, (resp: any) => {
                        toast.success(resp?.message)
                        resolve(resp);
                    }, (error: any) => {
                        toast.error(error);
                        reject(error);
                    });
                }).catch((error) => {
                    toast.error(error);
                    return null;
                });
            }

            if (recordFile && resp?.returnID) {
                const recordformData = new FormData();
                recordformData.append("inputFile", recordFile);
                recordformData.append("workRequestID", editData ? editData?.workRequestID : resp?.returnID);
                showLoader();
                const wraudioresp = await new Promise((resolve, reject) => workRequestAPI.UploadAttachment(recordformData, resolve, reject)).catch(error => null);


                if (recordData !== null) {
                    try {
                        /* const BACKEND_URL = "https://farm-chatbot-backend-d6f2bneug7a0baet.eastus2-01.azurewebsites.net/api/feedback";
                        const SERVER_API_KEY = "XKEg8hmXVyafdbjzECALrFijyRpdQNfLKjK8mPNLJqcya6fIm0XbpsNK62kVajbZ";
                        const response = await fetch(BACKEND_URL, {
                            method: 'POST',
                            headers: {
                                "Content-Type": "application/json",
                                "X-API-Key": SERVER_API_KEY
                            },
                            body: JSON.stringify(recordData)
                        }); */
                        workRequestAPI.ProcessFeedback(recordData, async (resp: any) => {
                        }, (error: any) => {
                            console.error("Error processing audio:", error);
                        });

                        if (!resp.ok) throw new Error(`Feedback API failed: ${resp.status}`);
                        const result = await resp.json();
                        console.log("Feedback API result:", result);
                    } catch (err) {
                        console.error("Error submitting feedback:", err);
                    }
                }

                hideLoader();
            }

            onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();

        }, (error: any) => {
            console.log('error =>', error);
            hideLoader();
            toast.error(error);
        });
        console.log("Submit payload", payload);
    };

    useEffect(() => {
        getWorkCode();
        getfacilitylist();
        GetPriorityList()
        GetStatusList();
        //setValue("requesterIDs", { label: `${loggedinuser?.firstName} ${loggedinuser?.lastName}`, value: loggedinuser?.userID });
    }, []);

    useEffect(() => {
        if (facilityWatch) {
            setValue("subFacilityIDs", null);
            getsubfacilityList(facilityWatch.value);
            console.log('XXXX call new sub facility api');
            //console.log("fsfsfsf wwww",facilityWatch?.data?.latitude);

        }
    }, [facilityWatch]);

    const GetWorkRequestByID = (assetID: any) => {
        const payload = {
            WorkRequestID: assetID
        }
        workRequestAPI.GetWorkRequestByID(payload, (data: any) => {
            if (data?.workRequestMappingList) {
                const assetIds = data?.workRequestMappingList?.map((item: any) => item.assetID).join(',');
                let payload: any = {
                    assetIDs: assetIds,
                };
                assetApi.getAssetsList(payload, (data: any) => {
                    setSelectedAssets(data.assetList ? data.assetList : []);
                    setRowData(data.assetList ? data.assetList : [])
                    //  setRowData(data.assetList ? data.assetList : []);
                    //setTotalRecords(data.totalRecord);
                }, (error: any) => { });
                console.log(assetIds);
            }
        }, (error: any) => { });
    };

    const formReset = () => {
        setAttachmentList([]);
        reset({
            incidentDate: new Date(),
            line: '',
            zone: '',
            description: '',
            notes: '',
            facilityID: null,
            workRequestStatusID: null,
            requesterIDs: { label: `${loggedinuser?.lastName} ${loggedinuser?.firstName}`, value: loggedinuser?.userID },
            priorityIDs: null,
            assetImage: ''
        });
        getWorkCode();
        setRowData([]);
        setSelectedAssets([]);

    }

    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reset = formReset;
        }
    }, [_ref])

    useEffect(() => {
        if (editData == null) {
            formReset();
        }
    }, [editData]);

    const changeAttachmentHandler = (e: any) => {
        setPartsAttachment(e.target.files);
    }

    useEffect(() => {
        if (editData) {
            reset({
                incidentDate: localDate(editData?.incidentDate),
                line: editData?.line,
                zone: editData?.zone,
                description: editData?.description,
                notes: editData?.notes,
                facilityID: getSelectedOption(editData.facilityID, facilityoption),
                workRequestStatusID: getSelectedOption(editData?.workRequestStatusID, statusList),
                requesterIDs: getSelectedOption(editData?.requsterID, users ? users : []),
                priorityIDs: getSelectedOption(editData?.workRequestPriorityID, priority),
            });
            setWorkRequestCode(editData?.workRequestCode)
            GetWorkRequestByID(editData?.workRequestID)
            showLoader();
            const payload: any = {
                workRequestID: editData?.workRequestID
            }
            workRequestAPI.GetWorkRequestImages(payload, (resp: any) => {
                hideLoader();
                console.log("resp===========?", resp)
                const attachmentList = resp?.files ? resp?.files : [];
                setAttachmentList(attachmentList);
            }, (error: any) => {
                hideLoader();
            })
        } else {
            formReset();
        }
    }, [editData, facilityoption, users, statusList, priority]);



    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users])
    return (
        <div className={`relative`}>
            {woloader && (
                <div className={`absolute p-8`} style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
                    <Loader />
                </div>
            )}
            <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={`${woloader ? `hidden` : `flex`} flex-col`}>
                <div className="flex-1 overflow-auto">
                    <h4 className="font-semibold text-[0.938rem] border-b border-gray-200 py-4 uppercase"> General </h4>
                    <div className="bg-green-50 py-2 px-3">
                        <h6 className="text-[0.813rem] font-semibold">Request ID</h6>
                        <p className="text-[0.813rem] font-normal mt-2">{workRequestCode}</p>
                    </div>

                    <CollectAudioData showOR={true} facilitiess={facilityoption.map((o: any) => o.label)} priorities={priority.map((o: any) => o.label)} onProcessing={() => {
                        setWoloader(true);
                    }} onCapture={(data: any) => {
                        setWoloader(false);
                        if (data && ((data.hasOwnProperty("error") && +data.error === 0) || !data.hasOwnProperty(`error`))) {
                            setRecordData(data);
                            console.log("Data from recording", data);
                            
                            setValue(`description`, (data?.description || ``));
                            setValue(`notes`, (data?.notes || ``));
                            setValue(`zone`, (data?.zone || ``));
                            setValue(`line`, (data?.line || ``));
                            if (data && data.hasOwnProperty(`priorityIDs`) && data?.priorityIDs) {
                                try {
                                    /*
                                    data.priorityIDs = data.priorityIDs.replace(/'/g, `"`);                                    
                                    const priorityidx = JSON.parse(data.priorityIDs);
                                    console.log("priorityidx", priorityidx)
                                    if (priorityidx && priorityidx.hasOwnProperty(`value`) && priorityidx.hasOwnProperty(`label`)) {
                                        setValue(`priorityIDs`, priorityidx);
                                    }
                                    */
                                    data.priorityIDs = data.priorityIDs.replace(/'/g, `"`);
                                    const selectedpriority = priority.find((o: any) => {
                                        return (o.label.toLowerCase() === data.priorityIDs.toLowerCase());
                                    });
                                    if (selectedpriority) {
                                        setValue(`priorityIDs`, {
                                            label: selectedpriority.label,
                                            value: selectedpriority.value,
                                            data: selectedpriority
                                        });
                                    }
                                } catch (errx: any) {
                                    console.log("priorities error", errx)
                                }
                            }
                            if (data && data.hasOwnProperty(`facilityID`) && data?.facilityID) {
                                try {
                                    //console.log("Tukeeee");
                                    /*
                                    data.facilityID = data.facilityID.replace(/None/g, `'None'`);
                                    data.facilityID = data.facilityID.replace(/'/g, `"`);
                                    const facilityidx = JSON.parse(data.facilityID);
                                    console.log("facilityidx", facilityidx);
                                    if (facilityidx && facilityidx.hasOwnProperty(`value`) && facilityidx.hasOwnProperty(`label`)) {
                                        setValue(`facilityID`, facilityidx);
                                    }                                    
                                    */
                                    data.facilityID = data.facilityID.replace(/None/g, `'None'`);
                                    data.facilityID = data.facilityID.replace(/'/g, `"`);
                                    const selectedfacility = facilityoption.find((o: any) => {
                                        return (o.label.toLowerCase() === data?.facilityID.toLowerCase());
                                    });
                                    if (selectedfacility) {
                                        setValue(`facilityID`, {
                                            label: selectedfacility.label,
                                            value: selectedfacility.value,
                                            data: selectedfacility
                                        });
                                    }
                                } catch (errx: any) {
                                    console.log("facility error", errx)
                                }
                            }
                            if (data.hasOwnProperty(`recordfile`) && data.recordfile) {
                                setRecordFile(data.recordfile);
                            }
                            /*
                            if (priority && Array.isArray(priority) && priority.length > 0 && data?.priorityIDs) {
                                var prioritytxt = data?.priorityIDs ? data?.priorityIDs.toLowerCase() : '';
                                console.log("Priorty", priority);
                                const priorityrow = priority.find((o: any) => o.label.toLowerCase() === prioritytxt);
                                if (priorityrow) {
                                    setValue(`priorityIDs`, priorityrow);
                                    setValue(`workRequestStatusID`, priorityrow);
                                }
                            }
                            
                            if (facilityoption && Array.isArray(facilityoption) && facilityoption.length > 0 && data?.facilityID) {
                                var facilitytxt = data?.facilityID ? data?.facilityID.toLowerCase() : '';
                                console.log("Facility", facilityoption);
                                const facilityrow = facilityoption.find((o: any) => o.label.toLowerCase() === facilitytxt);
                                if (facilityrow) {
                                    setValue(`facilityID`, facilityrow);
                                }
                            }
                            */
                            toast.success("Voice data filled successfully, Please check  and submit in order to create work request.");
                        } else {
                            toast.error(data?.error || "Unable to prase audio data!");
                        }
                        console.log("Final Parent component data is -> ", data);
                    }} />

                    <Controller
                        name="description"
                        rules={{ required: "Description is required" }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <Teaxtarea
                                label="Initial Description"
                                value={value}
                                onChange={onChange}
                                required
                                placeholder=""
                                error={errors.description?.message}
                            />
                        )}
                    />
                    <Controller
                        name='assetImage'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <FileUpload
                                label='Upload Picture'
                                value={value}
                                isMulti={true}
                                accept=".jpg, .jpeg, .png"
                                isFigmaType={true}
                                allowedExt={['jpg', 'jpeg', 'png', 'gif']}
                                retainFiles={true}
                                onChange={(e: any) => {
                                    changeAttachmentHandler(e);
                                    onChange(e.target.files[0])
                                }}
                                placeholder='Choose Processing Facility'
                                useEmbedMobileCam={false}

                            />
                        )}
                    />
                    {
                        attachmentList && attachmentList.length > 0 && <div  >
                            <h4 className='font-semibold text-[0.938rem] pb-4 uppercase'>Files</h4>
                            <div className='grid grid-cols-5 gap-3'>
                                {
                                    attachmentList.map((item: any, index: number) => {
                                        const found = imgExt.some((word) => item.originalFileName.includes(word));
                                        return (
                                            <div key={`attachmentList${index}`} className='border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative'>
                                                <Link to={item.fullFilePath} target='_blank'>
                                                    {found ?
                                                        <img src={item.fullFilePath} alt={item.originalFileName} className="max-w-full max-h-20" />
                                                        : item.originalFileName
                                                    }
                                                </Link>
                                                {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}

                                            </div>
                                        )
                                    })
                                }

                            </div>
                        </div>
                    }

                    <Controller
                        name="notes"
                        rules={{ required: "Notes is required" }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <Teaxtarea
                                label="Notes"
                                value={value}
                                onChange={onChange}
                                required
                                placeholder="Possible root cause, spare parts needed, special tools required"
                                error={errors.notes?.message}
                            />
                        )}
                    />
                    <Controller
                        name="requesterIDs"
                        control={control}
                        rules={{ required: "Requester is required" }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Requester"
                                value={value}
                                onChange={onChange}
                                required
                                disabled
                                placeholder="Choose Requester"
                                options={users ? users : []}
                                error={errors.requesterIDs?.message as any}
                            />
                        )}
                    />


                    <Controller
                        name="priorityIDs"
                        control={control}
                        rules={{ required: "Priority is required" }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Priority"
                                value={value}
                                onChange={onChange}
                                required
                                placeholder="Choose Priority"
                                options={priority}
                                error={errors.priorityIDs?.message as any}
                            />
                        )}
                    />

                    <Controller
                        name="facilityID"
                        control={control}
                        rules={{ required: "Facility is required" }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Select Facility"
                                value={value}
                                onChange={(selectOption: any) => {
                                    if (rowData.length > 0) {
                                        const pastFacid = rowData.find((item: any) => {
                                            return (item.facilityID == selectOption.value)
                                        });
                                        if (!pastFacid) {
                                            if (window.confirm("Are you sure you want to change the facility? This will remove all selected assets?")) {
                                                setRowData([]);
                                            } else {
                                                return;
                                            }
                                        }
                                    }
                                    console.log("Selected Facility", selectOption.value);
                                    onChange(selectOption);
                                }}
                                required
                                placeholder="Choose Facility"
                                options={facilityoption}
                                error={errors.facilityID?.message as any}
                            />
                        )}
                    />


                    <Controller
                        name="subFacilityIDs"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Select Sub Facility"
                                onChange={onChange}
                                isMulti={true}
                                value={value}
                                placeholder="Choose Sub Facility"
                                options={subfacilitylist}
                                error={errors.subFacilityIDs?.message as any}
                            />
                        )}
                    />

                    <Controller
                        name="line"
                        control={control}
                        render={({ field: { value, onChange } }) => (

                            <Input
                                label="# / Line #"
                                type="text"
                                value={value}
                                onChange={onChange}
                                placeholder="Enter Line"
                                error={errors.zone?.message}
                            />

                        )}
                    />

                    <div className="grid grid-cols-2 gap-2 relative z-10">
                        <Controller
                            name="incidentDate"
                            control={control}
                            rules={{ required: "IncidentDate is required" }}
                            render={({ field: { value, onChange } }) => (
                                <Datepicker
                                    label="Incident Date"
                                    required
                                    value={value}
                                    onChange={onChange}
                                    error={errors.incidentDate?.message}
                                />
                            )}
                        />
                        <Controller
                            name="zone"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label="Zone"
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    placeholder="Write Zone"
                                    error={errors.zone?.message}
                                />
                            )}
                        />
                    </div>



                    <Controller
                        name="workRequestStatusID"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Status"
                                value={value}
                                onChange={onChange}
                                disabled={workStatus}
                                placeholder="Choose Status"
                                className="mt-0"
                                options={statusList}
                                error={errors.workRequestStatusID?.message as any}
                            />
                        )}
                    />

                    <div className='flex justify-between  mb-2 my-6 mx-4 pb-4'>
                        <Label text={'Assets Impacted'} isBold={true} />
                        <p className='cursor-pointer text-[0.938rem] text-primary  font-normal' onClick={() => {
                            if (facilityWatch) {
                                createAssetModalRef?.current?.showModal();
                            } else {
                                toast.error("Please select facility")
                            }


                        }}>Select Impacted Asset</p>

                    </div>
                    <div
                        className="ag-theme-alpine"
                        style={{ height: "300px" }} // Set your height here
                    >
                        <AgGridReact
                            columnDefs={columnDefs} // Pass columnDefs
                            rowData={rowData} // Pass rowData
                            pagination={false}


                        />
                    </div>


                    <CreateAssetsModal _ref={createAssetModalRef} facility={facilityWatch} subFacility={subFacilityWatch} onContinue={(selectedAssets: any[]) => {
                        console.log("Selected Assets", selectedAssets);
                        //setValue("assets", selectedAssets);
                        // setSelectedAssets(selectedAssets);

                        selectedAssets?.map((assets: any) => {
                            setRowData((prevData: any) => {
                                // Check if prevData is an array, or initialize as an empty array
                                const updatedData = Array.isArray(prevData)
                                    ? [...prevData]
                                    : [];

                                // Debugging log to check the prevData and the assets being checked
                                console.log("prevData", prevData);
                                console.log("Checking assetCode for:", assets.assetID);

                                // Check if the assetCode of the current asset is not in the existing rowData
                                const assetExists = updatedData.some(
                                    (item: any) => item.assetID === assets.assetID
                                );
                                console.log("Asset exists:", assetExists);

                                // If the assetCode is not found, add the new asset
                                if (!assetExists) {
                                    updatedData.push(assets);
                                }

                                // Return the updatedData
                                return updatedData;
                            });
                        });
                        //  setRowData(selectedAssets)
                        createAssetModalRef?.current?.close();
                    }} />

                </div>
                <div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200 sticky bottom-0 bg-white z-10">
                    <Button type="button" theme="secondary" onClick={() => {
                        formReset();
                        onCancel()
                    }}>
                        Cancel
                    </Button>
                    {/* disabled={selectedAssets.length == 0 ? true : false} */}
                    <Button type="submit"  >
                        Save
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default CreateWorkRequest;
